import { render, staticRenderFns } from "./PlayerItem.vue?vue&type=template&id=032ed3c8&"
import script from "./PlayerItem.vue?vue&type=script&lang=js&"
export * from "./PlayerItem.vue?vue&type=script&lang=js&"
import style0 from "./PlayerItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports